export default __webpack_public_path__ + "static/media/edit-black-icon.d3b69ef4.svg";